import React, { useState } from 'react';

function PhoneMockup({ imageUrl }) {
  const [scale, setScale] = useState(1.0);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const phoneW = 320;
  const phoneH = 640;
  const bezel = 14;
  const radius = 46;
  const screenRadius = 32;
  const screenX = bezel;
  const screenY = bezel;
  const screenW = phoneW - bezel * 2;
  const screenH = phoneH - bezel * 2;

  const islandW = 100;
  const islandH = 28;
  const islandX = phoneW / 2 - islandW / 2;
  const islandY = screenY + 12;

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({ x: e.clientX - offsetX, y: e.clientY - offsetY });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setOffsetX(e.clientX - dragStart.x);
    setOffsetY(e.clientY - dragStart.y);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const resetPosition = () => {
    setScale(1.0);
    setOffsetX(0);
    setOffsetY(0);
  };

  return (
    <div className="phone-mockup-container fade-in">
      {imageUrl && (
        <div className="phone-controls">
          <div className="control-group">
            <label>🔍 Zoom: {(scale * 100).toFixed(0)}%</label>
            <input
              type="range"
              min="0.5"
              max="2.0"
              step="0.05"
              value={scale}
              onChange={(e) => setScale(parseFloat(e.target.value))}
              className="zoom-slider"
            />
          </div>
          <div className="control-group">
            <label>↔️ Horizontal</label>
            <input
              type="range"
              min="-100"
              max="100"
              step="1"
              value={offsetX}
              onChange={(e) => setOffsetX(parseFloat(e.target.value))}
              className="position-slider"
            />
          </div>
          <div className="control-group">
            <label>↕️ Vertical</label>
            <input
              type="range"
              min="-100"
              max="100"
              step="1"
              value={offsetY}
              onChange={(e) => setOffsetY(parseFloat(e.target.value))}
              className="position-slider"
            />
          </div>
          <button onClick={resetPosition} className="reset-btn">
            🔄 Reset
          </button>
        </div>
      )}

      <div 
        className="phone-svg-wrapper"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
      >
        <svg
          viewBox={`0 0 ${phoneW} ${phoneH}`}
          xmlns="http://www.w3.org/2000/svg"
          className="phone-svg"
        >
          <defs>
            <clipPath id="screen-clip">
              <rect
                x={screenX}
                y={screenY}
                width={screenW}
                height={screenH}
                rx={screenRadius}
                ry={screenRadius}
              />
            </clipPath>

            <filter id="phone-shadow" x="-15%" y="-8%" width="130%" height="120%">
              <feDropShadow dx="0" dy="12" stdDeviation="18" floodColor="#000" floodOpacity="0.7" />
              <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor="#000" floodOpacity="0.5" />
            </filter>

            <linearGradient id="screen-glare" x1="0%" y1="0%" x2="60%" y2="100%">
              <stop offset="0%" stopColor="#ffffff" stopOpacity="0.07" />
              <stop offset="40%" stopColor="#ffffff" stopOpacity="0.01" />
              <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
            </linearGradient>

            <linearGradient id="body-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3a3a3c" />
              <stop offset="40%" stopColor="#1c1c1e" />
              <stop offset="100%" stopColor="#0f0f11" />
            </linearGradient>

            <linearGradient id="edge-highlight" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#6e6e73" stopOpacity="0.9" />
              <stop offset="30%" stopColor="#3a3a3c" stopOpacity="0.5" />
              <stop offset="70%" stopColor="#1c1c1e" stopOpacity="0.3" />
              <stop offset="100%" stopColor="#48484a" stopOpacity="0.6" />
            </linearGradient>
          </defs>

          <rect
            x="0" y="0"
            width={phoneW} height={phoneH}
            rx={radius} ry={radius}
            fill="url(#body-grad)"
            filter="url(#phone-shadow)"
          />

          <rect
            x="0.5" y="0.5"
            width={phoneW - 1} height={phoneH - 1}
            rx={radius} ry={radius}
            fill="none"
            stroke="url(#edge-highlight)"
            strokeWidth="1.5"
          />

          <rect x="-3" y="160" width="4" height="46" rx="2" fill="#3a3a3c" />
          <rect x="-3" y="220" width="4" height="46" rx="2" fill="#3a3a3c" />
          <rect x="-3" y="112" width="4" height="30" rx="2" fill="#3a3a3c" />
          <rect x={phoneW - 1} y="190" width="4" height="64" rx="2" fill="#3a3a3c" />

          <rect
            x={screenX} y={screenY}
            width={screenW} height={screenH}
            rx={screenRadius} ry={screenRadius}
            fill="#0a0a0a"
          />

          {imageUrl && (
            <g clipPath="url(#screen-clip)">
              <image
                href={imageUrl}
                x={screenX + offsetX}
                y={screenY + offsetY}
                width={screenW * scale}
                height={screenH * scale}
                preserveAspectRatio="xMidYMid slice"
              />
            </g>
          )}

          <rect
            x={screenX} y={screenY}
            width={screenW} height={screenH}
            rx={screenRadius} ry={screenRadius}
            fill="url(#screen-glare)"
          />

          <rect
            x={screenX} y={screenY}
            width={screenW} height={screenH}
            rx={screenRadius} ry={screenRadius}
            fill="none"
            stroke="#000"
            strokeWidth="3"
            strokeOpacity="0.4"
          />

          <rect
            x={islandX}
            y={islandY}
            width={islandW}
            height={islandH}
            rx={islandH / 2}
            ry={islandH / 2}
            fill="#000"
          />
          <circle
            cx={islandX + islandW - 22}
            cy={islandY + islandH / 2}
            r="7"
            fill="#1a1a1a"
          />
          <circle
            cx={islandX + islandW - 22}
            cy={islandY + islandH / 2}
            r="3.5"
            fill="#0d0d0d"
          />
        </svg>
      </div>
      
      {imageUrl && (
        <p className="drag-hint">
          🖱️ Drag image to move · Use sliders to adjust
        </p>
      )}
    </div>
  );
}

export default PhoneMockup;
